// shared/ui/atoms/Marquee.tsx
import React, { FC, ReactNode, useRef, useState, useLayoutEffect, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
interface MarqueeProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Скорость анимации в пикселях в секунду */
  speed?: number;
  /** Направление анимации */
  direction?: 'left' | 'right';
  /** Пауза при наведении */
  pauseOnHover?: boolean;
  /** Размер фейда справа, если контент не помещается (в rem или px) */
  maskSize?: string;
  /** Активировать анимацию (по умолчанию true) */
  enabled?: boolean;
  /** Задержка перед началом анимации (в секундах) */
  delay?: number;
}
const Marquee: FC<MarqueeProps> = ({
  children,
  speed = 30,
  direction = 'left',
  pauseOnHover = false,
  maskSize = '0.625rem',
  enabled = true,
  delay = 0,
  ...rest
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [animationDuration, setAnimationDuration] = useState(0);
  useLayoutEffect(() => {
    const checkOverflow = () => {
      const container = containerRef.current;
      const content = contentRef.current;
      if (container && content) {
        const isOver = content.offsetWidth > container.clientWidth;
        setIsOverflowing(isOver);
        if (isOver) {
          setAnimationDuration(content.offsetWidth / speed);
        }
      }
    };
    const timer = setTimeout(checkOverflow, 10);
    const resizeObserver = new ResizeObserver(checkOverflow);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }
    return () => {
      clearTimeout(timer);
      resizeObserver.disconnect();
    };
  }, [speed, children, enabled]);
  const shouldAnimate = enabled && isOverflowing;
  return <MarqueeContainer ref={containerRef} maskSize={maskSize} pauseOnHover={pauseOnHover} {...rest} data-fade={isOverflowing ? 'true' : 'false'}>
      <MarqueeTrack data-animating={shouldAnimate ? 'true' : 'false'} direction={direction} duration={animationDuration} delay={delay}>
        <MarqueeContent ref={contentRef}>{children}</MarqueeContent>
        {/* Дублируем контент для бесшовной анимации */}
        {shouldAnimate && <MarqueeContent aria-hidden="true">{children}</MarqueeContent>}
      </MarqueeTrack>
    </MarqueeContainer>;
};
export default Marquee;
interface MarqueeContainerProps {
  maskSize: string;
  pauseOnHover: boolean;
}
const _exp2 = /*#__PURE__*/() => ({
  maskSize
}) => maskSize;
const _exp3 = /*#__PURE__*/() => ({
  pauseOnHover
}) => pauseOnHover ? 'paused' : 'auto';
const MarqueeContainer = /*#__PURE__*/styled('div')({
  name: "MarqueeContainer",
  class: "mm6ctji",
  propsAsIs: false,
  vars: {
    "mm6ctji-0": [_exp2()],
    "mm6ctji-1": [_exp3()]
  }
});
interface MarqueeTrackProps {
  direction: 'left' | 'right';
  duration: number;
  delay: number;
}
const _exp4 = /*#__PURE__*/() => ({
  duration
}) => duration;
const _exp5 = /*#__PURE__*/() => ({
  delay
}) => delay;
const _exp6 = /*#__PURE__*/() => ({
  direction
}) => direction === 'left' ? '0' : '-50%';
const _exp7 = /*#__PURE__*/() => ({
  direction
}) => direction === 'left' ? '-50%' : '0';
const MarqueeTrack = /*#__PURE__*/styled('div')({
  name: "MarqueeTrack",
  class: "m1ltn1z1",
  propsAsIs: false,
  vars: {
    "m1ltn1z1-0": [_exp4(), "s"],
    "m1ltn1z1-1": [_exp5(), "s"],
    "m1ltn1z1-2": [_exp6()],
    "m1ltn1z1-3": [_exp7()]
  }
});
const MarqueeContent = /*#__PURE__*/styled('div')({
  name: "MarqueeContent",
  class: "m1vzyjk2",
  propsAsIs: false
});

require("./Marquee.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Marquee.tsx");